import React from 'react';
import styled from 'styled-components';
import { Icon } from '../../../../components/common/icon/Icon';

interface FavoriteButtonProps {
  isFavorite: boolean;
  onFavoriteClick?: () => void;
}

export const FavoriteButton = ({ isFavorite, onFavoriteClick }: FavoriteButtonProps) => {
  return (
    <Button onClick={onFavoriteClick} as="button" type="button">
      <Icon name={'Star'} width={20} height={20} fill={isFavorite ? '#FF9500' : '#C6C6D5'} />
    </Button>
  );
};

const Button = styled.button`
  display: flex;
  width: 32px;
  height: 32px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;

  border-radius: var(--radius-large, 16px);
  border: 1px solid var(--Light-Scheme-Monochrome-grey20, #ececf3);
  background: var(--Light-Scheme-Monochrome-white, #fff);
`;
